@if (block && !hidden) {
  <section class="text-image block-container">
    <div class="row content" [class.image-right]="block.layout === 'image_right_text_left'">
      @if (block.mediaImage) {
        <div class="col-12 col-sm-6 image">
          <img [cropImage]="block.mediaImage | preSignedUrl | async" [additionalOptions]="{width: 600}" [attr.alt]="block.mediaImage.alt">
        </div>
      }
      <div class="col-12 col-sm-6 text ck-text" parseHref [rtl]="block.langcode" [class.col-sm-12]="!block.mediaImage" [innerHtml]="block.text | safeHtml"></div>
    </div>
  </section>
}
